/**
 * Purchase orders list — generic procure-to-pay order inbox.
 *
 * @see prototype/purchases/purchase-orders.html — V1.1 baseline (list)
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { PoListPage } from "../../../../features/purchase-orders/index.ts";

export const Route = createFileRoute("/(workspace)/procurement/purchase-orders/")({
  component: PurchaseOrdersListRoute,
});

function PurchaseOrdersListRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Procurement", to: "/" }, { label: "Purchase orders" }]}
    >
      <PoListPage />
    </WorkspaceShell>
  );
}
